import { createSelector } from 'reselect';
import { getCachedFullContainers } from './omjs';
import { IState } from '../services/root-reducer';
import { getChildren } from './containers';

export const getObjectsListData = createSelector(
    (state: IState, containerCode: string) => {
        const container = state.operations.CONTAINERS.data.find(cont => cont.code === containerCode);
        let allChilds = [ container, ...getChildren(state, container.id) ];
        let childs = allChilds.filter(cont => cont.type !== 'folder' && cont.selected);
        return { container, childs, allChilds };
    },
    (state: IState) => (
        state.operations.FILTERED_IDS['data']
    ),
    state => getCachedFullContainers(state),
    (data, filteredIds, fullContainers) => {
        const contCodes = data.childs.map(c => c.code);
        const allContCodes = data.allChilds.map(c => c.code);
        let allObjectsLength = 0;
        const containers = fullContainers.filter(cont => {
            if (allContCodes.includes(cont.get('code'))) {
                allObjectsLength += cont.objects?.getArray().length || 0;
            }
            return contCodes.includes(cont.get('code'));
        });

        let objects = [];
        let unfilteredObjects = [];

        for (let cont of containers) {
            let filteredContIds = filteredIds[cont.get('code')];
            objects = cont.objects.getArray().reduce((arr, obj) => {
                const geom = obj.getGeometry();
                if (!geom) return arr;
                let newObj = {
                    ...obj['_attributes'],
                    id: obj['id'],
                    layerCode: obj.options.layerCode,
                    area: obj['_attributes'][cont['areaField']],
                    coordinates: geom?.coordinates
                };
                if (
                    !filteredContIds
                    || filteredContIds.includes(obj.getId())
                ) {
                    arr.push(newObj);
                }
                unfilteredObjects.push(newObj);
                return arr;
            }, objects);
        }

        return {
            containerName: data.container.name,
            containers: data.childs,
            objects: objects,
            unfilteredObjects: unfilteredObjects,
            allObjectsLength: allObjectsLength
        };
    }
);

export const getFavListData = createSelector(
    (state: IState) => {
        const codes = Object.keys(state.favorites.items);
        return state.operations.CONTAINERS.data.filter(cont => codes.includes(cont.code));
    },
    (state: IState) => state.favorites.items,
    (state: IState) => getCachedFullContainers(state),
    (containers, favData, fullContainers) => {
        const codes = Object.keys(favData);
        const conts = fullContainers.filter(cont => codes.includes(cont.get('code')));

        let objects = [];
        for (let cont of conts) {
            const favIds = favData[cont.get('code')];
            objects = cont.objects.getArray().reduce((arr, obj) => {
                if (favIds.includes(obj.getId())) {
                    arr.push({
                        ...obj['_attributes'],
                        id: obj['id'],
                        layerCode: obj.options.layerCode,
                        area: obj['_attributes'][cont['areaField']],
                        coordinates: obj.getGeometry().coordinates
                    });
                }
                return arr;
            }, objects);
        }

        return { containers, objects };
    }
);
